import { avg, groupBy, sum } from "simple-utils";
import { Account } from "../../models/Account";
import { FullReportEntry } from "../../models/FullReportEntry";
import { getRegion } from "../../utils/state-utils";


export function groupByRegion(accounts: FullReportEntry[]):Record<string, FullReportEntry[]>{
    return groupBy(accounts, a => getRegion(a.state));
}

export function groupByState(accounts: FullReportEntry[]):Record<string, FullReportEntry[]>{
    return groupBy(accounts, a => a.state);
}

function getOnlyNumber(n:number){
    if(n === null) return 0;
    if(isNaN(n)) return 0;
    return n;
}

export function miniReport(accounts: FullReportEntry[]){
    return {
        numAccounts: accounts.length,
        totalCost: sum(accounts, a => a.totalCost),
        totalGoal: sum(accounts, a => a.goal),
        totalLeads: sum(accounts, a => a.nLeads),
        totalExpectedLeads: sum(accounts, a => a.expectedLeads),
        avgLeads: avg(accounts, a => a.nLeads),
        avgCPL: avg(accounts, a => a.nLeads ? a.totalCost / a.nLeads : 0),
        avgCPM: avg(accounts, a => getOnlyNumber(a.totalCost / a.impressions * 1000)),
    }
}

export type MiniReport = ReturnType<typeof miniReport>;